import React from "react";
import { Heart, Leaf, Activity, HandHeart } from "lucide-react";
import { ImageSeven } from "../assets/images";

const FiveTab = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 via-green-50 to-purple-50 px-4 py-10 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-green-600 mb-4 leading-snug">
            How Empfly Pulse Supports Recovery?
          </h1>
          <p className="text-base sm:text-lg lg:text-xl text-gray-700 max-w-3xl mx-auto px-2">
            Comprehensive care across emotional, nutritional, physical, and
            caregiver dimensions.
          </p>
        </div>

        {/* Main Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-stretch">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {[
              {
                title: "Emotional Wellness",
                desc: "Therapy, mood tracking, and guided journaling.",
                icon: (
                  <Heart
                    className="w-8 h-8 text-pink-500"
                    fill="currentColor"
                  />
                ),
                bg: "bg-pink-100",
                border: "border-pink-100",
              },
              {
                title: "Nutritional Recovery",
                desc: "Meal plans, taste-based coaching, and mindful eating.",
                icon: <Leaf className="w-8 h-8 text-green-600" />,
                bg: "bg-green-100",
                border: "border-green-100",
              },
              {
                title: "Physical Rehabilitation",
                desc: "Mobility, fatigue tracking, and sleep routines.",
                icon: <Activity className="w-8 h-8 text-green-600" />,
                bg: "bg-green-100",
                border: "border-green-100",
              },
              {
                title: "Caregiver Support",
                desc: "Tools, alerts, and community support for caregivers.",
                icon: <HandHeart className="w-8 h-8 text-pink-500" />,
                bg: "bg-pink-100",
                border: "border-pink-100",
              },
            ].map((item, i) => (
              <div
                key={i}
                className={`bg-white rounded-3xl p-6 sm:p-8 shadow-lg hover:shadow-xl transition-shadow duration-300 border ${item.border} flex flex-col justify-between h-full`}
              >
                <div
                  className={`flex items-center justify-center w-16 h-16 rounded-full mb-6 mx-auto relative ${item.bg}`}
                >
                  {item.icon}
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-green-600 text-center mb-3">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-center text-sm sm:text-base leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>

          {/* Full Height & Width Image */}
          <div className="w-full h-full bg-white">
            <img
              src={ImageSeven}
              alt="Illustration"
              className="w-full h-full object-cover rounded-3xl shadow-lg"
            />
          </div>
        </div>

        {/* Bottom Message */}
        <div className="mt-16 text-center">
          <div className="inline-flex flex-col sm:flex-row items-center space-y-3 sm:space-y-0 sm:space-x-3 bg-white rounded-full px-6 sm:px-8 py-4 shadow-lg border border-pink-100 max-w-3xl mx-auto">
            <div className="flex items-center space-x-3">
              <Heart className="w-6 h-6 text-pink-500" fill="currentColor" />
              <div className="w-6 h-6 bg-pink-100 rounded-full flex items-center justify-center">
                <div className="w-3 h-3 bg-pink-400 rounded-full"></div>
              </div>
              <Activity className="w-6 h-6 text-green-600" />
            </div>
            <p className="text-base sm:text-lg font-medium text-gray-700 text-center sm:text-left">
              Pulse blends AI, expert care, and human empathy to support
              recovery at every step.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FiveTab;
